<template>
  <section style="height: auto;">
    <v-app style="" class="payment">
      <div class="image">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="150px"
          fill="#fff"
          viewBox="0 0 210.31 32.08"
        >
          <g id="Camada_2" data-name="Camada 2">
            <g id="Camada_1-2" data-name="Camada 1">
              <path
                d="M31.32 31.43h22.14v-7.17H40.92v-4.98h11.29v-7.17H40.92V7.83h12.54V.65H31.32v30.78zM75.92 22.09L69.91.65h-8.78l10.55 30.78h8.35L90.58.65h-8.61l-6.05 21.44zM98.61 31.43h20.42v-5.14h-13.91v-7.91h12.54v-5.15h-12.54V5.79h13.91V.65H98.61v30.78zM148.75 16a9.3 9.3 0 0 0 1.49-5.4v-1a11.36 11.36 0 0 0-.52-3.48 7.59 7.59 0 0 0-1.62-2.83 7.75 7.75 0 0 0-2.85-1.92A11.18 11.18 0 0 0 141 .65h-12.33v30.78H134V19.59h5.19l6.31 11.85h5.84L144.41 19a7.83 7.83 0 0 0 4.35-3m-5.21-1.9a5.65 5.65 0 0 1-3.81 1.12H134V5.06h6q4.89 0 4.89 4.8v.6a4.51 4.51 0 0 1-1.3 3.59M179.7 3.83A8.61 8.61 0 0 0 176 1a18.15 18.15 0 0 0-11.85 0 8.85 8.85 0 0 0-3.72 2.85 11.16 11.16 0 0 0-1.92 4.45 28.69 28.69 0 0 0-.54 5.84v3.8a30.23 30.23 0 0 0 .52 5.86 11.13 11.13 0 0 0 1.86 4.45 8.6 8.6 0 0 0 3.65 2.84 18.14 18.14 0 0 0 11.85 0 8.84 8.84 0 0 0 3.72-2.85 11.18 11.18 0 0 0 1.92-4.45 28.75 28.75 0 0 0 .54-5.84v-3.8a30.21 30.21 0 0 0-.52-5.86 11.14 11.14 0 0 0-1.86-4.45m-2 14.12a23.63 23.63 0 0 1-.48 5.23 7.85 7.85 0 0 1-1.43 3.2 4.94 4.94 0 0 1-2.35 1.61 12.75 12.75 0 0 1-6.74 0 4.93 4.93 0 0 1-2.38-1.62 7.63 7.63 0 0 1-1.4-3.2 24.69 24.69 0 0 1-.45-5.23v-3.8a23.7 23.7 0 0 1 .48-5.21 7.86 7.86 0 0 1 1.43-3.22 4.94 4.94 0 0 1 2.38-1.62 12.75 12.75 0 0 1 6.74 0 4.94 4.94 0 0 1 2.38 1.62 7.66 7.66 0 0 1 1.4 3.2 24.68 24.68 0 0 1 .45 5.23zM210 19.89a6.38 6.38 0 0 0-1.19-2.4 6.63 6.63 0 0 0-2.27-1.77 12.48 12.48 0 0 0-3.59-1.06l-4-.61a7.31 7.31 0 0 1-4.26-1.67 5 5 0 0 1-1.19-3.61 5.59 5.59 0 0 1 1.88-4.6q1.88-1.53 6.2-1.54a24.55 24.55 0 0 1 3.85.3 22.58 22.58 0 0 1 3.37.78l.61-2.21A19.91 19.91 0 0 0 206 .58a22.71 22.71 0 0 0-4.17-.37 17.67 17.67 0 0 0-4.54.54 10.34 10.34 0 0 0-3.46 1.58 6.89 6.89 0 0 0-2.18 2.59 8.12 8.12 0 0 0-.76 3.59v.22a7.9 7.9 0 0 0 1.66 5.34q1.66 1.92 5.56 2.49l3.89.56a11 11 0 0 1 2.83.76 4.52 4.52 0 0 1 1.71 1.25 4.44 4.44 0 0 1 .84 1.71 8.39 8.39 0 0 1 .24 2q0 3.42-1.88 5t-6.33 1.58a24.56 24.56 0 0 1-4.37-.37 36.88 36.88 0 0 1-3.67-.84l-.52 2.29a22.63 22.63 0 0 0 3.85 1 27.53 27.53 0 0 0 4.63.39 17 17 0 0 0 4.89-.63 9.56 9.56 0 0 0 3.44-1.77 7.21 7.21 0 0 0 2-2.72 8.83 8.83 0 0 0 .67-3.48v-.52a11.42 11.42 0 0 0-.35-2.85M11.13.65H0v30.78h21.62v-8.31H11.13V.65z"
                class="logo-leveros-svg"
              ></path>
            </g>
          </g>
        </svg>
      </div>
      <div class="creditCard">
        <div v-if="this.pagamentoRealizado" class="infosCard">
          <h4 v-html="mensagemPagamento"></h4>
        </div>
        <div v-if="!this.pagamentoRealizado" class="infosCard">
          <h4>Pedido: {{ nrPedido }}</h4>
          <h2>Cartão de Crédito</h2>
          <div class="rows">
            <label class="input-group-addon cartaoCredito1"
              ><i class="fas fa-credit-card"></i
            ></label>
            <input
              type="text"
              placeholder="Número do Cartão de Crédito"
              name="txtCartaoCredito1"
              id="txtCartaoCredito1"
              @change="validaBandeiraCartao(1)"
              required
              @paste="preventPaste($event)"
              v-model="numeroCartao"
            />
          </div>
          <input
            name="txtBandeira1"
            type="text"
            id="txtBandeira1"
            class="hidden"
          />
          <div class="rows">
            <label for=""><i class="fas fa-user-alt"></i></label>

            <input type="text" placeholder="Nome impresso no cartão" required v-model="nomeCartao" @keypress="somenteLetras($event)" @paste="preventPaste($event)"/>
          </div>
          <div class="rows">
            <label for=""><i class="fas fa-calendar-week"></i></label>

            <input
              type="text"
              class="input small"
              placeholder="MM"
              title="Mês"
              required
              maxlength="2"
              @paste="preventPaste($event)"
              v-model="mesValidade"
            />
            <input
              type="text"
              class="input small"
              maxlength="4"
              placeholder="AAAA"
              title="Ano"
              required
              @paste="preventPaste($event)"
              v-model="anoValidade"
            />
          </div>
          <div class="rows">
            <label for=""><i class="fas fa-shield-alt"></i></label>

            <input class="small" type="text" placeholder="CVV" required v-model="codigoSeguranca" @paste="preventPaste($event)" maxlength="4"/>
          </div>
          <div class="rows">
            <label for=""><i class="fas fa-id-card"></i></label>

            <input type="text" placeholder="CPF do Titular" required v-model="cpfTitular" @paste="preventPaste($event)"/>
          </div>
          <div class="rows">
            <label for=""><i class="fas fa-list-ol"></i></label>
            <input
              type="text"
              placeholder="CPF do Titular"
              required
              :value="qtdParcelas + ' x ' + this.$options.filters.toCurrency((parseFloat(valorTotal) / qtdParcelas))"
              disabled
            />
          </div>
          <div class="rows">
            <label for="">R$</label>

            <input
              :value="parseFloat(valorTotal).toFixed(2)"
              name="txtValor1"
              type="number"
              id="txtValor1"
              @change="splitValor()"
              min="1"
              step="any"
              required
              disabled
            />
          </div>
          <div class="rows">
            <p id="error">
              Verifique o valor inserido, ele não pode ser maior que o devido.
            </p>
          </div>
          <div class="secondCreditCard">
            <!-- <p @click="secondCreditCard = !secondCreditCard">
              Adicionar segundo cartão
            </p> -->

            <div class="dateCreditCard" v-if="secondCreditCard">
              <div class="rows">
                <label class="input-group-addon cartaoCredito2"
                  ><i class="fas fa-credit-card"></i
                ></label>
                <input
                  type="number"
                  placeholder="Número do Cartão de Crédito"
                  name="txtCartaoCredito2"
                  id="txtCartaoCredito2"
                  @change="validaBandeiraCartao(2)"
                  required
                />
              </div>
              <input
                name="txtBandeira2"
                type="text"
                id="txtBandeira2"
                class="hidden"
              />
              <div class="rows">
                <label for=""><i class="fas fa-user-alt"></i></label>

                <input type="text" placeholder="Nome impresso no cartão" />
              </div>
              <div class="rows">
                <label for=""><i class="fas fa-calendar-week"></i></label>

                <input
                  type="number"
                  class="input small"
                  placeholder="MM"
                  title="Mês"
                />
                <input
                  type="number"
                  class="input small"
                  placeholder="AA"
                  title="Ano"
                />
              </div>
              <div class="rows">
                <label for=""><i class="fas fa-shield-alt"></i></label>

                <input class="small" type="number" placeholder="CVV"/>
              </div>
              <div class="rows">
                <label for=""><i class="fas fa-id-card"></i></label>

                <input type="number" placeholder="CPF do Titular" />
              </div>
              <div class="rows">
                <label for=""><i class="fas fa-list-ol"></i></label>

                <select
                  name="parcelasCredito"
                  id="parcelasCredito"
                  class="input medium"
                  title="Parcelas Cartão de Crédito"
                >
                  <option value="parcelas">
                    Selecione a quantidade de parcelas
                  </option>
                  <option value="1">1x</option>
                  <option value="1">2x</option>
                  <option value="1">3x</option>
                  <option value="1">4x</option>
                  <option value="1">5x</option>
                  <option value="1">6x</option>
                  <option value="1">7x</option>
                  <option value="1">8x</option>
                  <option value="1">9x</option>
                  <option value="1">10x</option>
                  <option value="1">11x</option>
                  <option value="1">12x</option>
                </select>
              </div>
              <div class="rows">
                <label for="">R$</label>

                <input
                  name="txtValor2"
                  type="number"
                  id="txtValor2"
                  min="1"
                  step="any"
                  placeholder=""
                />
              </div>
            </div>
          </div>

          <a @click="sendPayment()">FINALIZAR PEDIDO</a>
        </div>
      </div>

      <div v-if="!pagamentoRealizado" class="order">
        <h2>Resumo do Pedido - {{ nrPedido }}</h2>
        <div class="products">
          <div class="item" v-for="(info, i) in itensPedido" :key="i">
            <div class="item__image">
              <img :src="info.linkimagem" :alt="info.dsConjunto" />
            </div>
            <div class="item__description">
              <p>{{ info.dsConjunto }}</p>
              <p>
                Quantidade: <span>{{ info.qtd }}</span>
              </p>
              <p>
                Valor: <span>{{ info.VlLiquido | toCurrency }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="footer">
          <!-- <div class="address">
            <h3>Endereço de Entrega:</h3>
            <div class="address__item" v-for="(add, i) in infos" :key="i">
              <h4>
                {{ add.dadosCliente.enderecoentrega.cidade }} -
                {{ add.dadosCliente.enderecoentrega.uf }}
              </h4>
              <p>
                {{ add.dadosCliente.enderecoentrega.logradouro }},
                {{ add.dadosCliente.enderecoentrega.nrresidencia }}
              </p>
              <p>{{ add.dadosCliente.enderecoentrega.bairro }}</p>
              <p>
                {{ add.dadosCliente.enderecoentrega.cidade }} -
                {{ add.dadosCliente.enderecoentrega.uf }}
              </p>
              <p>{{ add.dadosCliente.enderecoentrega.cep }}</p>
            </div>
          </div> -->
          <div class="totals">
            <h3>Totais:</h3>
            <div class="totals__item" v-for="(val, i) in infos" :key="i">
              <h4>{{ (val.vlliquido + val.vltotalfrete) | toCurrency }}</h4>
              <input
                name="txtValorTotal"
                type="text"
                :value="val.vlliquido + val.vltotalfrete"
                id="txtValorTotal"
                class="hidden"
              />
              <p>
                Valor Bruto: <span>{{ val.vlBruto | toCurrency }}</span>
              </p>
              <p>
                Descontos: <span>{{ val.vlDesconto | toCurrency }}</span>
              </p>
              <p>
                Valor Líquido: <span>{{ val.vlliquido | toCurrency }}</span>
              </p>
              <p>
                Valor do Frete: <span>{{ val.vltotalfrete | toCurrency }}</span>
              </p>
              <p>
                Valor Total:
                <span>{{ (val.vlliquido + val.vltotalfrete) | toCurrency }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    
      <v-dialog
        v-model="loading"
        persistent
        width="300"
      >
        <v-card
          color="var(--standardGreen)"
          dark
        >
          <v-card-text style="padding: 27px;" >
            Enviando pagamento, por favor aguarde...
            <v-progress-linear
              style="margin-top: 15px"
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-app>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      token: null,
      infos: [],
      itensPedido: [],
      nrPedido: null,
      sequencia: null,
      valorTotal: null,
      secondCreditCard: false,
      qtdParcelas: null,
      numeroCartao: null,
      mesValidade: null,
      anoValidade: null,
      codigoSeguranca: null,
      cpfTitular: null,
      nomeCartao: null,
      pagamentoRealizado: false,
      mensagemPagamento: null,
      ip: null,
      codigoYapay: null,
      loading: false,
      cards: [
        { bandeira: 'visa', validacao: /^4[0-9]{12}(?:[0-9]{3})/, yapayID: 3},
        { bandeira: 'master', validacao: /^5[1-5][0-9]{14}/, yapayID: 4},
        { bandeira: 'master', validacao: /^2[1-5][0-9]{14}/, yapayID: 4},
        { bandeira: 'amex', validacao: /^3[47][0-9]{13}/, yapayID: 5},
        { bandeira: 'hiper', validacao: /^(606282\d{10}(\d{3})?)|(3841\d{15})/, yapayID: 20},
        { bandeira: 'elo', validacao: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/, yapayID: 16},
        // { bandeira: 'diners', validacao: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/, yapayID: 0},
        // { bandeira: 'discover', validacao: /^6(?:011|5[0-9]{2})[0-9]{12}/, yapayID: 0},
        // { bandeira: 'jcb', validacao: /^(?:2131|1800|35\d{3})\d{11}/, yapayID: 0},
        // { bandeira: 'aura', validacao: /^(5078\d{2})(\d{2})(\d{11})$/, yapayID: 0},
      ]
    };
  },
  methods: {
    async getDados() {
      let dados = JSON.parse(localStorage.getItem("login"));

      if (dados != undefined) {
        this.token = dados.token;
      } else {
        this.token = "";
      }

      var url = new URL(window.location.href);
      var order = url.searchParams.get("Order");
      let sequencia = url.searchParams.get("Seq") ?
        window.atob(url.searchParams.get("Seq")) : null;

      // Se caso tiver o número da sequencia (Parametrizado para a solar)
      if (sequencia) {
        const response = await axios.get(
           `https://www.leverosintegra.com.br/MAP/api/newyapay?idpedido=${order}&newYapay=true`
          //`http://qa.leverosintegra.com.br/map/api/OrderDetails?idpedido=${order}`
        );
        this.infos = response.data;
      
      // LVI Antigo
      } else {
        const response = await axios.get(
           `https://www.leverosintegra.com.br/MAP/api/OrderDetails?idpedido=${order}`
          //`http://qa.leverosintegra.com.br/map/api/OrderDetails?idpedido=${order}`
        );
        this.infos = response.data;
      }
    

      if (this.infos[0].Bloqueios !== null) {
        let bloqueio = this.infos[0].Bloqueios.filter(s => s.DT_LIBERACAO === null);

        if(bloqueio.length > 0){
          this.mensagemPagamento = `Pedido com bloqueio! Descrição: ${bloqueio[0].DS_BLOQUEIO}`;
          this.pagamentoRealizado = true;
          return;
        }
      }

      if (this.infos[0].observacao) {
        this.mensagemPagamento = this.infos[0].observacao;
        this.pagamentoRealizado = true;
        return;
      }

      axios.get(`https://www.leverosintegra.com.br/map/api/ip`).then((res) => {
        this.ip = res.data[0];
      });

      this.nrPedido = this.infos[0].NRPedido;

      // Se caso tiver o número da sequencia (Parametrizado para a solar)
      if (sequencia) {
        const pagamento = this.infos[0].frmPagamento.find(p => p.id === parseFloat(sequencia))

        this.qtdParcelas = pagamento.nrparcela
        this.valorTotal = pagamento.vlTotal
        this.sequencia = sequencia

        if (pagamento.situacao) {
          this.mensagemPagamento = `Pagamento em monitoramento!`;
          this.pagamentoRealizado = true;
          return;
        }
      } else {
        this.qtdParcelas = this.infos[0].frmPagamentoIncompleta[0].nrparcela;
  
        this.pagamentoRealizado = this.infos[0].pagamentoRealizado;
        if (this.pagamentoRealizado) {
          this.mensagemPagamento = 'Pagamento do pedido já realizado!';
        }

        let valores = this.infos;

        valores.find(
          (valor) => (this.valorTotal = valor.vlliquido + valor.vltotalfrete)
        );
  
        let itens = this.infos;

        itens.forEach(function (e) {
          if (e.cjPedido.length != -1) {
            itens = e.cjPedido;
          }
        });
        this.itensPedido = itens;
      }
    },
    splitValor() {
      let valorTotal = document.getElementById("txtValorTotal").value;
      let valorCartao1 = document.getElementById("txtValor1").value;
      let diferenca = parseFloat(
        (parseFloat(valorTotal) - parseFloat(valorCartao1)).toFixed(2)
      );
      if (diferenca < 0) {
        document.getElementById("error").style.display = "block";
        document.getElementById("txtValor1").value = valorTotal;
        return;
      }
      document.getElementById("txtValor2").value = diferenca;
      document.getElementById("error").style.display = "none";
    },
    validaBandeiraCartao(cartao) {
      window.yapay.FingerPrint().getFingerPrint();
      var tgdeveloper = {
        /**
         * getCardFlag
         * Return card flag by number
         *
         * @param cardnumber
         */
        getCardFlag: function (cardnumber, cards) {
          var numberCard = cardnumber.replace(/[^0-9]+/g, "");

          let cartaoVerificado = cards.filter(card => {
            if (card.validacao.test(numberCard)) {
              return card;
            } else {
              return false;
            }
          })
          return cartaoVerificado[0] ? cartaoVerificado[0].bandeira : false;
        },
      };

      if (cartao == 1) {
        let bandeira = tgdeveloper.getCardFlag(
          this.numeroCartao,
          this.cards
        );

        document.getElementById("txtBandeira1").value = bandeira;
        document.getElementsByClassName("cartaoCredito1")[0].innerHTML =
          '<i class="fas fa-credit-card" style="position: relative;z-index: -999;"></i>';
        document
          .getElementsByClassName("cartaoCredito1")[0]
          .setAttribute(
            "style",
            'background-image: url("https://leverosintegra.com.br/img/' +
              bandeira +
              '.png");background-size: 35px;background-repeat: no-repeat;'
          );
      } else if (cartao == 2) {
        let bandeira = tgdeveloper.getCardFlag(
          document.getElementById("txtCartaoCredito2").value,
          this.cards
        );
        document.getElementById("txtBandeira2").value = bandeira;
        document.getElementsByClassName("cartaoCredito2")[0].innerHTML =
          '<i class="fas fa-credit-card" style="position: relative;z-index: -999;"></i>';
        document
          .getElementsByClassName("cartaoCredito2")[0]
          .setAttribute(
            "style",
            'background-image: url("https://leverosintegra.com.br/img/' +
              bandeira +
              '.png");background-size: 35px;background-repeat: no-repeat;'
          );
      }
    },

    sendPayment() {

      if (!this.numeroCartao || !this.mesValidade || !this.anoValidade || !this.codigoSeguranca || !this.nomeCartao || !this.cpfTitular) {
        alert("Todos os campos são obrigatórios! Por favor verifique!")
        return;
      }

      let numCartaoLimpo = this.somenteNumeros(this.numeroCartao);
      if (numCartaoLimpo.length  < 13 || numCartaoLimpo.length  > 16 || !this.validaCartao(numCartaoLimpo)) {
        alert("Número de cartão inválido! Por favor verifique!")
        return;
      }

      if (this.possuiNumero(this.nomeCartao)) {
        alert("O nome do cartão não pode possuir números! Por favor verifique!");
        return;
      }

      if (!this.isNumber(this.mesValidade)) {
        alert("Mês de vencimento do cartão inválido! Por favor verifique!")
        return;
      }

      if (this.anoValidade.length < 2 || this.anoValidade.length == 3 || this.anoValidade.length > 4 || !this.isNumber(this.anoValidade)) {
        alert("Ano de vencimento do cartão inválido! Por favor verifique!")
        return;
      }

      if (this.anoValidade.length == 2) {
        this.anoValidade = '20' + this.anoValidade
      }

      if (!this.isNumber(this.codigoSeguranca)) {
        alert("Código de segurança inválido! Por favor verifique!")
        return;
      }

      let cpfLimpo = this.somenteNumeros(this.cpfTitular);
      if (!this.isValidCPF(cpfLimpo)) {
        alert("CPF inválido! Por favor verifique!")
        return;
      }

      // Recupera Finger Print
      // let fingerprint = window.yapay.FingerPrint({ env: 'sandbox' }).getFingerPrint();
      let fingerprint = window.yapay.FingerPrint().getFingerPrint(); // Produção
      let nrPedido = this.nrPedido.split("-");

      let data = {
        nr_pedido: nrPedido[1],
        cpf: cpfLimpo,
        ip: this.ip,
        fingerprint,
        payment_value: this.valorTotal,
        sequencia: this.sequencia,
        payment: {
          card_number: numCartaoLimpo,
          card_expdate_month: this.mesValidade,
          card_expdate_year: this.anoValidade,
          card_cvv: this.codigoSeguranca,
          split: this.qtdParcelas,
          card_name: this.nomeCartao,
          payment_method_id: this.codigoYapay,
        }
      }
      
      this.loading = true;
      axios({
        method: "post",
         url: this.sequencia ? `https://www.leverosintegra.com.br/MAP/api/newyapay?capturePayment=true` : `https://www.leverosintegra.com.br/MAP/api/yapay?capturePayment=true`,
        //url: this.sequencia ? `http://qa.leverosintegra.com.br/map/api/newyapay?capturePayment=true` : `http://qa.leverosintegra.com.br/map/api/yapay?capturePayment=true`,
        data: data,
      }).then(res => {
        this.loading = false;
        let arrayRetorno = res.data;
        // Verifica o retorno
        if (arrayRetorno.idstatus == '00') {
          this.mensagemPagamento = arrayRetorno.mensagem;
          this.pagamentoRealizado = true;

        } else if (arrayRetorno.idstatus == 'err') {
          alert("Erro na finalização - Transação não realizada! " + arrayRetorno.mensagem)
        
        } else if (arrayRetorno.idstatus == 'errGeral') {
          let msg = "Erro na finalização - Transação não realizada. Entre em contato com o Vendedor!";
          msg += arrayRetorno.mensagem ? ' ' + arrayRetorno.mensagem : '';
          alert(msg);
        
        } else {
          if (arrayRetorno.mensagem == 'Transação em análise' && arrayRetorno.idstatus == '12321') {
            this.mensagemPagamento = arrayRetorno.mensagem;
            this.pagamentoRealizado = true;
          } else {
            alert("Transação não realizada, verifique os dados do cartão! " + arrayRetorno.mensagem + '. Código: ' + arrayRetorno.idstatus);
          }
        }
      }).catch(err => {
        this.loading = false;
        console.log(err);
        alert("Erro ao se conectar com o servidor! Tente novamente! " + err);
      }) 
    },

    possuiNumero(palavra){
      const regex = /[0-9]/;
      return regex.test(palavra);
    },

    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },

    somenteNumeros(str) {
      let onlyNumbers = str.replace(/\D+/g, '');
      return onlyNumbers;
    },

    isValidCPF(cpf) {
      if (typeof cpf !== "string") return false
      cpf = cpf.replace(/[\s.-]*/igm, '')
      if (
          !cpf ||
          cpf.length != 11 ||
          cpf == "00000000000" ||
          cpf == "11111111111" ||
          cpf == "22222222222" ||
          cpf == "33333333333" ||
          cpf == "44444444444" ||
          cpf == "55555555555" ||
          cpf == "66666666666" ||
          cpf == "77777777777" ||
          cpf == "88888888888" ||
          cpf == "99999999999" 
      ) {
          return false
      }
      var soma = 0
      var resto
      for (let i = 1; i <= 9; i++) 
          soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
      resto = (soma * 10) % 11
      if ((resto == 10) || (resto == 11))  resto = 0
      if (resto != parseInt(cpf.substring(9, 10)) ) return false
      soma = 0
      for (let i = 1; i <= 10; i++) 
          soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
      resto = (soma * 10) % 11
      if ((resto == 10) || (resto == 11))  resto = 0
      if (resto != parseInt(cpf.substring(10, 11) ) ) return false
      return true
    },

    validaCartao(nrCartao) {
      for (var cartao in this.cards) {
        if (nrCartao.match(this.cards[cartao].validacao)) {
          this.codigoYapay = this.cards[cartao].yapayID;
          return true;
        }
      }
      this.codigoYapay = null; 
      return false;
    },

    somenteLetras(event) {
      let tecla = event.keyCode;
      if (tecla >= 48 && tecla <= 57 || tecla == 45 || tecla == 43 || tecla == 42 || tecla == 61 || tecla == 47 || tecla == 46){
        event.preventDefault();
      }
    },

    preventPaste(event) {
      event.preventDefault();
    }

  },

  beforeMount() {
    this.getDados();
  },

  mounted() {
    let yapayScript = document.createElement('script')
    yapayScript.setAttribute('src', 'https://static.traycheckout.com.br/js/finger_print.js')
    document.head.appendChild(yapayScript)
  },
};
</script>


<style lang="scss" scoped>
#error {
  color: red;
  font-size: 0.95rem;
  display: none;
}

.hidden {
  display: none !important;
}
.payment {
  background: var(--standardGreen);
  padding: 30px 0;

  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
  }

  .creditCard {
    padding: 60px 0;
    .infosCard {
      display: flex;
      flex-direction: column;
      background: var(--customWhite);
      border-radius: 10px;
      width: 95%;
      margin: 0 auto;
      padding: 25px;

      @media (min-width: 769px) {
        width: 40%;
      }

      h4 {
        padding-bottom: 20px;
        color: var(--standardGreen);
        font-size: 0.95rem;
      }

      h2 {
        padding-bottom: 5px;
        color: var(--standardGreen);
        font-size: 1.2rem;
        border-bottom: 1px solid var(--customGray-100);
      }

      label {
        font-size: 1.4rem;
        color: var(--customGray-500);
        background: var(--customGray-100);
        border-radius: 5px 0 0 5px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          vertical-align: middle;
        }
      }

      input,
      select {
        border: 1px solid var(--customGray-100);
        border-radius: 0 5px 5px 0;
        padding: 5px;
        outline: none;
        width: 60%;
        color: var(--customGray-800);

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        input[type="number"] {
          -moz-appearance: textfield;
        }
      }

      .rows {
        padding: 10px 0;
        display: flex;
      }

      .small {
        width: 20%;
      }

      a {
        background: var(--standardGreen);
        color: var(--customWhite);
        padding: 10px;
        border-radius: 10px;
        text-decoration: none;
        margin-top: 30px;
        text-align: center;
        font: 700 1rem "Soleto", sans-serif;

        &:hover {
          background: var(--customDarkGreen);
        }
      }

      .secondCreditCard {
        margin-top: 20px;
        p {
          color: var(--standardGreen);
          cursor: pointer;
          text-decoration: underline;

          &:hover {
            color: var(--customDarkGreen);
          }
        }

        .dateCreditCard {
          margin-top: 30px;
          border-top: 1px solid var(--customGray-100);
          padding: 30px 0;
        }
      }
    }
  }

  .order {
    width: 95%;
    margin: 0 auto;
    background: var(--customWhite);
    border-radius: 10px;
    padding: 30px;

    @media (min-width: 769px) {
      width: 60%;
    }

    h2 {
      font-size: 1.2rem;
      color: var(--standardGreen);
    }

    .item {
      display: flex;
      align-items: center;
      border-bottom: 1px solid var(--customGray-100);
      padding: 10px 0;
      flex-direction: column;

      @media (min-width: 441px) {
        flex-direction: row;
      }

      &__description {
        margin-left: 20px;

        p {
          font-weight: 700;
          color: var(--customGray-800);

          span {
            font-weight: 500;
          }
        }
      }
    }

    .footer {
      margin-top: 30px;
      display: flex;

      .address,
      .totals {
        flex: 1;

        h3 {
          margin-bottom: 15px;
          font-size: 1rem;
          color: var(--standardGreen);
        }

        &__item {
          h4 {
            color: var(--customDarkGreen);
            padding-bottom: 10px;
          }

          p {
            font: 500 0.85rem/1.6 "Soleto", sans-serif;
            color: var(--customGray-800);
          }
        }
      }
    }
  }
}
</style>